import { createFileRoute } from '@tanstack/react-router'
import { ReconstructionPage } from 'pages/reconstruction/ReconstructionPage'

export const Route = createFileRoute('/reconstruction')({
  component: RouteComponent,
  staticData: {
    title: 'Reconstruction',
  },
})

function RouteComponent() {
  return <ReconstructionPage />
}
